import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AccountsService } from '../../../services/identity/accounts.service';
import { StepProgressBarComponent } from '../../../shared/components/step-progress-bar/step-progress-bar.component';
import { CurrentThemeStore } from '../../../stores/current-theme.store';
import { OnboardingUserCompletionComponent } from '../../components/onboarding-user-completion/onboarding-user-completion.component';
import { OnboardingUserInfosComponent } from '../../components/onboarding-user-infos/onboarding-user-infos.component';
import { OnboardingUserInterestsComponent } from '../../components/onboarding-user-interests/onboarding-user-interests.component';
import { OnboardingUserSkillsComponent } from '../../components/onboarding-user-skills/onboarding-user-skills.component';

@Component({
    selector: 'app-onboarding-page',
    templateUrl: './onboarding-page.component.html',
    styleUrls: ['./onboarding-page.component.scss'],
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [
                style({ opacity: 0 }), // Initial state of the element before it appears
                animate('300ms ease-in', style({ opacity: 1 })), // Final state after the animation
            ]),
        ]),
    ],
})
export class OnboardingPageComponent implements OnInit {
    public isLoading = false;
    public step = 1;
    @ViewChild('stepProgressBar') public stepProgressBar: StepProgressBarComponent;
    @ViewChild(OnboardingUserCompletionComponent) public userCompletionComponent: OnboardingUserCompletionComponent;
    @ViewChild(OnboardingUserInfosComponent) public userInfoComponent: OnboardingUserInfosComponent;
    @ViewChild(OnboardingUserInterestsComponent) public userInterestsComponent: OnboardingUserInterestsComponent;
    @ViewChild(OnboardingUserSkillsComponent) public userSkillsComponent: OnboardingUserSkillsComponent;

    constructor(
        private readonly accountService: AccountsService,
        readonly currentThemeStore: CurrentThemeStore,
        private readonly router: Router,
    ) {}

    public get logoSrc() {
        return this.currentThemeStore.currentTheme.platformLogoUrl;
    }

    public arePersonalInfosCompleted(): boolean {
        return (
            !!this.accountService.currentUser.jobTitle &&
            !!this.accountService.currentUser.officePhone &&
            !!this.accountService.currentUser.mobilePhone &&
            !!this.accountService.currentUser.geographicalAreaId &&
            !!this.accountService.currentUser.city &&
            !!this.accountService.currentUser.linkedIn
        );
    }

    public async completeOnboarding() {
        this.isLoading = true;
        await this.userCompletionComponent.save();
    }

    public goToHomePage(success: Event) {
        if (success) {
            this.router.navigate(['welcome']);
            return;
        }
        this.isLoading = false;
        return;
    }

    public ngOnInit(): void {
        if (this.arePersonalInfosCompleted()) {
            this.step = 2;
            if (this.accountService.currentUser.skills.length > 0) {
                this.step = 3;
                if (this.accountService.currentUser.interests.length > 0) {
                    this.step = 4;
                }
            }
        }
    }

    public async onNextStep() {
        this.isLoading = true;
        let isSaved = false;

        switch (this.step) {
            case 1:
                isSaved = await this.userInfoComponent.save();
                break;
            case 2:
                isSaved = await this.userSkillsComponent.save();
                break;
            case 3:
                isSaved = await this.userInterestsComponent.save();
                break;
        }

        if (isSaved) {
            this.goToNextStep();
        }

        this.isLoading = false;
    }

    public onPreviousStep() {
        if (this.step === 4) {
            this.userCompletionComponent.removePicture();
        }
        this.step--;
        this.stepProgressBar.progress = this.step;
    }

    public skipStep() {
        this.goToNextStep();
    }

    private goToNextStep() {
        this.step++;
        this.stepProgressBar.progress = this.step;
    }
}
